<template>
  <div class="">
    <b-modal
      v-model="internalShow"
      id="ViewForwardEmail"
      centered
      hide-header-close
      size="md"
    >
      <template #modal-header>
        <div
          class="popUp-header text-center w-100"
          style="border-bottom: 0px !important"
        >
          <h4 class="heading-size">Forward Email</h4>
        </div>
        <b-button
          variant="close"
          aria-label="Close"
          class="position-absolute"
          style="right: 1rem; top: 1rem"
          @click="internalShow = false"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </template>
      <div class="">
        <label for="">Email Address</label>
        <input
          type="text"
          placeholder="Enter one or more email address separated by comma or semicolon"
          class="input-field"
          v-model="email"
        />
      </div>
      <template #modal-footer>
        <!-- Custom footer if needed, otherwise hide-footer will work -->
        <b-button variant="secondary" @click="internalShow = false">
          Close
        </b-button>
        <b-button
          class="univ-btn w-auto p-2 h-100 mt-1"
          @click="forward()"
          :disabled="!email"
        >
          Forward
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ForwardEmail",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    emailId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      internalShow: this.show,
      email: "",
    };
  },
  watch: {
    show(newVal) {
      this.internalShow = newVal;
    },
    internalShow(newVal) {
      this.email = "";
      this.$emit("update:show", newVal);
    },
  },
  methods: {
    validateEmail(input) {
      if (!input) return false;
      const emails = input
        .split(/[,;]+/)
        .map((e) => e.trim())
        .filter((e) => e !== "");
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // basic email regex
      return emails.length > 0 && emails.every((email) => regex.test(email));
    },

    async forward() {
      if (!this.validateEmail(this.email)) {
        this.$notify("Please enter valid email address.", "error");
        return;
      }
      let url = `v2/forward-resend-email`;
      let loader = this.$loading.show();
      try {
        const response = await axios.post(url, {
          id: this.emailId,
          action: "forward",
          forward_email: this.email,
        });
        if (response.data.success === false) {
          this.$notify(response.data.message, "error");
          return;
        }
        this.$notify(response.data.message, "success");
      } catch (err) {
        this.$notify("An error occurred while resending email.", "error");
      } finally {
        loader.hide();
        this.internalShow = false;
        this.email = "";
      }
    },
  },
};
</script>

<style scoped>
.btn-container {
  position: absolute;
  right: 1rem;
  top: 1rem;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  padding: 0;
}
.btn-container:hover {
  opacity: 0.75;
}
#ViewForwardEmail .modal-header .btn-close {
  right: -0.5rem !important;
  top: -1.5rem !important;
  background: #fff !important;
  opacity: 1 !important;
}
.status-bar {
  background-color: #efefef;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
}
</style>
